// Newsletter popup
$(document).on("touchstart click mouseenter keyup", "#newsletter-pop", function(e) {
  console.log("Engaged");
  clearTimeout(goTimeout);
});
  
$(document).on("mouseleave", "#newsletter-pop", function(e) {
  console.log("Leaving");
  clearTimeout(goTimeout);
  myTimer();
});
  
setTimeout( function(){ 
  $('.newsletter-popup').show();
  myTimer(); 
  }  , 8000 );
  
var goTimeout;

function myTimer() {
  goTimeout = setTimeout(function() {
    $('.newsletter-popup').hide();
    console.log("Hiding");
	}, 5000);
};

$('.news-close').click(function() {
	$('.newsletter-popup').hide();
});

// $(document).ready(function() {
//     if ($.cookie('noShowWelcome')) $('.welcome').hide();
//     else {
//         $("#close-welcome").click(function() {
//             $(".welcome").fadeOut(1000);
//             $.cookie('noShowWelcome', true);    
//         });
//     }
// });